module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer_de-0c9d939a187230dedbc915753e7b9e7b.jpg";